<div class="voice-dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon [color]="getStatusColor()">{{ getStatusIcon() }}</mat-icon>
      Voice Command
    </h2>
    <button mat-icon-button 
            matTooltip="Close"
            (click)="close()"
            class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Status Section -->
    <div class="status-section">
      <div class="status-header">
        <h3>Status</h3>
      </div>
      
      <div class="status-items compact">
        <!-- Ready/Listening -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.READY || currentStatus === VoiceProcessStatus.LISTENING" [class.completed]="currentStatus !== VoiceProcessStatus.READY && currentStatus !== VoiceProcessStatus.LISTENING && currentStatus !== VoiceProcessStatus.ERROR">
          <mat-icon [color]="currentStatus === VoiceProcessStatus.LISTENING ? 'accent' : 'primary'">
            {{ currentStatus === VoiceProcessStatus.LISTENING ? 'hearing' : 'mic' }}
          </mat-icon>
          <span>{{ currentStatus === VoiceProcessStatus.LISTENING ? 'Listening' : 'Ready' }}</span>
          <mat-spinner *ngIf="currentStatus === VoiceProcessStatus.LISTENING" diameter="16"></mat-spinner>
        </div>

        <!-- Transcribing -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.TRANSCRIBING" [class.completed]="currentStatus !== VoiceProcessStatus.TRANSCRIBING && currentStatus !== VoiceProcessStatus.LISTENING && currentStatus !== VoiceProcessStatus.READY && currentStatus !== VoiceProcessStatus.ERROR">
          <mat-icon color="primary">sync</mat-icon>
          <span>Transcribing</span>
          <mat-spinner *ngIf="currentStatus === VoiceProcessStatus.TRANSCRIBING" diameter="16"></mat-spinner>
        </div>

        <!-- Getting Intent -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.GETTING_INTENT" [class.completed]="currentStatus === VoiceProcessStatus.GENERATING_PROMPT || currentStatus === VoiceProcessStatus.WAITING_AI_RESPONSE || currentStatus === VoiceProcessStatus.CREATING_PLAYLIST || currentStatus === VoiceProcessStatus.COMPLETED">
          <mat-icon color="primary">psychology</mat-icon>
          <span>Understanding</span>
          <mat-spinner *ngIf="currentStatus === VoiceProcessStatus.GETTING_INTENT" diameter="16"></mat-spinner>
        </div>

        <!-- Generating Prompt -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.GENERATING_PROMPT" [class.completed]="currentStatus === VoiceProcessStatus.WAITING_AI_RESPONSE || currentStatus === VoiceProcessStatus.CREATING_PLAYLIST || currentStatus === VoiceProcessStatus.COMPLETED">
          <mat-icon color="primary">auto_awesome</mat-icon>
          <span>Prompting</span>
          <mat-spinner *ngIf="currentStatus === VoiceProcessStatus.GENERATING_PROMPT" diameter="16"></mat-spinner>
        </div>

        <!-- Waiting AI Response -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.WAITING_AI_RESPONSE" [class.completed]="currentStatus === VoiceProcessStatus.CREATING_PLAYLIST || currentStatus === VoiceProcessStatus.COMPLETED">
          <mat-icon color="primary">cloud_sync</mat-icon>
          <span>AI Response</span>
          <mat-spinner *ngIf="currentStatus === VoiceProcessStatus.WAITING_AI_RESPONSE" diameter="16"></mat-spinner>
        </div>

        <!-- Creating Playlist -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.CREATING_PLAYLIST" [class.completed]="currentStatus === VoiceProcessStatus.COMPLETED">
          <mat-icon color="primary">playlist_add</mat-icon>
          <span>Creating</span>
          <mat-spinner *ngIf="currentStatus === VoiceProcessStatus.CREATING_PLAYLIST" diameter="16"></mat-spinner>
        </div>

        <!-- Completed -->
        <div class="status-item" [class.active]="currentStatus === VoiceProcessStatus.COMPLETED" [class.completed]="currentStatus === VoiceProcessStatus.COMPLETED">
          <mat-icon color="primary">check_circle</mat-icon>
          <span>Done!</span>
        </div>
      </div>
    </div>

    <!-- Speech Display Section -->
    <div class="speech-section">
      <div class="speech-header">
        <h3>Speech Recognition</h3>
      </div>
      
      <mat-card class="transcript-card">
        <mat-card-content>
          <p class="interim-text" *ngIf="interimTranscript">{{ interimTranscript }}</p>
          <p class="final-text" *ngIf="finalTranscript">{{ finalTranscript }}</p>
          <p class="hint-text" *ngIf="isActuallyListening && !interimTranscript && !finalTranscript">
            <mat-icon>mic</mat-icon>
            Speak now...
          </p>
          <p class="ready-text" *ngIf="currentStatus === VoiceProcessStatus.READY && !isActuallyListening">
            <mat-icon>mic</mat-icon>
            Click "Start Listening" to begin
          </p>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Status Message -->
    <div class="status-message" [class.error]="currentStatus === VoiceProcessStatus.ERROR" *ngIf="currentStatus === VoiceProcessStatus.ERROR || (currentStatus !== VoiceProcessStatus.READY && currentStatus !== VoiceProcessStatus.LISTENING)">
      <mat-icon>{{ currentStatus === VoiceProcessStatus.ERROR ? 'error' : 'info' }}</mat-icon>
      {{ statusMessage }}
    </div>

    <!-- Not Supported Message -->
    <div *ngIf="!speechSupported" class="not-supported">
      <mat-chip color="warn">
        <mat-icon>warning</mat-icon>
        Voice recognition not supported in this browser
      </mat-chip>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="close()" [disabled]="isProcessing()">
      Cancel
    </button>
    <button mat-raised-button 
            color="primary"
            *ngIf="canRetry()" 
            (click)="retry()"
            [disabled]="!speechSupported">
      <mat-icon>mic</mat-icon>
      {{ currentStatus === VoiceProcessStatus.READY ? 'Start Listening' : 'Try Again' }}
    </button>
  </mat-dialog-actions>
</div>